// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/mine-game-tile.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mine-fairness-game-table {
  min-height: 260px;
  display: flex;
  pointer-events: none;
}
@media screen and (min-width: 1200px) {
  .mine-fairness-game-table {
    min-height: 100%;
  }
}
.mine-fairness-game-table .mine-body {
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 20px;
  margin: auto;
  border-radius: 12px;
  background-color: var(--primary);
  background-size: cover;
  background-repeat: no-repeat;
}
@media screen and (min-width: 992px) {
  .mine-fairness-game-table .mine-body {
    max-width: 380px;
  }
}
.mine-fairness-game-table .mine-body .mines {
  aspect-ratio: 1/1;
  position: relative;
  min-width: 4.5ch;
  min-height: 4.5ch;
  padding: 0;
  display: flex;
  align-items: self-start;
  -webkit-transform-style: preserve-3d;
  background: none;
  border: none;
}
.mine-fairness-game-table .mine-body .mines img {
  height: 100%;
  object-fit: contain;
  width: 100%;
  max-height: 100%;
}
.mine-fairness-game-table .mine-body .mines img.disabled {
  filter: contrast(0.7);
}
.mine-fairness-game-table .mine-body .mines.rotateY {
  position: relative;
  transition-duration: 0.8s !important;
}
.mine-fairness-game-table .mine-body .mines .mine-grid-box {
  border: 1px solid var(--zinc-700);
  overflow: hidden;
  background-color: var(--zinc-700);
  background-origin: border-box;
  height: 100%;
  width: 100%;
  border-radius: 4px;
  font-weight: 800;
  font-size: clamp(1rem, 8vw, 2.5rem);
  display: flex;
  align-items: center;
  justify-content: center;
}
.mine-fairness-game-table .mine-body .mines .mine-grid-box.gonga-mine-bet-locked-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  border: 1px solid var(--TabBgActive);
  background-color: var(--TabBgActive);
}
.mine-fairness-game-table .mine-body .mines .mine-grid-box.bet-locked-img {
  padding: 10px;
  border: 1px solid var(--NumberBg);
  background-color: var(--NumberBg);
}
.mine-fairness-game-table .mine-body .mines .mine-grid-box.mine-skull {
  border: 1px solid #DC566B;
  background: linear-gradient(180deg, #13151A 0%, #521814 100%);
  padding: 10px;
  box-shadow: none;
}
.mine-fairness-game-table .mine-body .mines .mine-grid-box.mine-star {
  border: 1px solid var(--TabBgActive);
  background-color: var(--TabBgActive);
  padding: 10px;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/games/Mines/GameTheme/GongaMineGame/components/FairnessMineTable/FairnessMineTable.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,oBAAA;AACF;AAAE;EAJF;IAKI,gBAAA;EAGF;AACF;AADE;EACE,kBAAA;EACA,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,sBAAA;EACA,4BAAA;AAGJ;AADI;EAdF;IAeI,gBAAA;EAIJ;AACF;AAFI;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,oCAAA;EAYA,gBAAA;EACA,YAAA;AAPN;AAJM;EACE,YAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAMR;AALQ;EACE,qBAAA;AAOV;AACM;EACE,kBAAA;EAIA,oCAAA;AACR;AAEM;EACE,iCAAA;EACA,gBAAA;EACA,iCAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AAEQ;EACE,yDAAA;EACA,2BAAA;EACA,oCAAA;EACA,oCAAA;AAAV;AAGQ;EACE,aAAA;EACA,iCAAA;EACA,iCAAA;AADV;AAIQ;EACE,yBAAA;EACA,6DAAA;EACA,aAAA;EACA,gBAAA;AAFV;AAKQ;EACE,oCAAA;EACA,oCAAA;EACA,aAAA;EACA,gBAAA;AAHV","sourcesContent":[".mine-fairness-game-table {\n  min-height: 260px;\n  display: flex;\n  pointer-events: none;\n  @media screen and (min-width: 1200px) {\n    min-height: 100%;\n  }\n\n  .mine-body {\n    position: relative;\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    padding: 20px;\n    margin: auto;\n    border-radius: 12px;\n    background-color: var(--primary);\n    background-size: cover;\n    background-repeat: no-repeat;\n\n    @media screen and (min-width: 992px) {\n      max-width: 380px;\n    }\n\n    .mines {\n      aspect-ratio: 1/1;\n      position: relative;\n      min-width: 4.5ch;\n      min-height: 4.5ch;\n      padding: 0;\n      display: flex;\n      align-items: self-start;\n      -webkit-transform-style: preserve-3d;\n\n      img {\n        height: 100%;\n        object-fit: contain;\n        width: 100%;\n        max-height: 100%;\n        &.disabled {\n          filter: contrast(0.7);\n        }\n      }\n\n      background: none;\n      border: none;\n\n\n      &.rotateY {\n        position: relative;\n        -webkit-transition-duration: 0.8s !important;\n        -moz-transition-duration: 0.8s !important;\n        -o-transition-duration: 0.8s !important;\n        transition-duration: 0.8s !important;\n      }\n\n      .mine-grid-box {\n        border: 1px solid var(--zinc-700);\n        overflow: hidden;\n        background-color: var(--zinc-700);\n        background-origin: border-box;\n        height: 100%;\n        width: 100%;\n        border-radius: 4px;\n        font-weight: 800;\n        font-size: clamp(1rem, 8vw, 2.5rem);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        &.gonga-mine-bet-locked-img {\n          background-image: url(../../../GongaMineGame/images/mine-game-tile.png);\n          background-position: center;\n          border: 1px solid var(--TabBgActive);\n          background-color: var(--TabBgActive);\n        }\n\n        &.bet-locked-img {\n          padding: 10px;\n          border: 1px solid var(--NumberBg);\n          background-color: var(--NumberBg);\n        }\n\n        &.mine-skull {\n          border: 1px solid #DC566B;\n          background: linear-gradient(180deg, #13151A 0%, #521814 100%);\n          padding: 10px;\n          box-shadow: none;\n        }\n\n        &.mine-star {\n          border: 1px solid var(--TabBgActive);\n          background-color: var(--TabBgActive);\n          padding: 10px;\n          box-shadow: none;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
